import { AuditAPI } from './audit';
import { FragmentsAPI } from './fragments';
import { ReportsAPI } from './reports';
import { SegmentsAPI } from './segments';
import { StationsAPI } from './stations';
import { StreamerBoxAPI } from './streamerBox';
import { TranscriptionAPI } from './transcriptions';

export const allApiModules = {
  audit: AuditAPI,
  fragments: FragmentsAPI,
  segments: SegmentsAPI,
  stations: StationsAPI,
  streamerBox: StreamerBoxAPI,
  transcriptions: TranscriptionAPI,
  reports: ReportsAPI,
};
